import React from "react";
import { ShieldCheck } from "lucide-react";

const GuaranteeSection = () => {
  return (
    <section className="section" style={{ background: "#000" }}>
      <div className="container" style={{ maxWidth: 900 }}>
        <div className="guarantee">
          <div style={{ display: "flex", alignItems: "flex-start", gap: 24, flexWrap: "wrap" }}>
            <div style={{
              width: 76, height: 76, borderRadius: 999,
              background: "linear-gradient(135deg, #FFE47A, #F5C400 60%, #B88700)",
              color: "#1a1200",
              display: "flex", alignItems: "center", justifyContent: "center",
              flex: "none",
            }}>
              <ShieldCheck size={38} strokeWidth={2.2} />
            </div>
            <div style={{ flex: 1, minWidth: 280 }}>
              <div className="eyebrow">GARANTIA VSA</div>
              <h3 style={{ marginTop: 8, fontSize: 26, fontWeight: 800, lineHeight: 1.2 }}>
                7 dias para testar. Ou seu dinheiro de volta.
              </h3>
              <p style={{ marginTop: 16, color: "rgba(255,255,255,0.8)", fontSize: 16, lineHeight: 1.7 }}>
                <strong>Você tem 7 dias para testar a VSA Comunidade</strong> e, se não for pra você, devolvemos 100% do valor. Sem perguntas, sem burocracia.
              </p>
              <p style={{ marginTop: 12, color: "rgba(255,255,255,0.8)", fontSize: 16, lineHeight: 1.7 }}>
                E mais: se você entrar, <strong>aplicar o método por 90 dias</strong>, postar ao menos 2 vídeos por dia no TikTok Shop, <strong>e não fizer pelo menos R$5.000 em vendas — devolvemos tudo + R$500 no PIX.</strong>
              </p>
              <p style={{ marginTop: 14, color: "#F5C400", fontWeight: 800 }}>
                Porque aqui a gente não vende promessa. A gente garante resultado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
